export default "__VITE_ASSET__BiRh48FL__"